import type * as React from "react";
import { Breadcrumbs, Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { COLORS } from "components/v3/Theme/colors";

export type BreadcrumbSegment = {
  label: React.ReactNode;
  to?: string;
};

export type BreadcrumbTrailProps = {
  segments: BreadcrumbSegment[];
  ariaLabel?: string;
};

const linkSlate = COLORS.DARK_GRAY_2;
const currentMuted = COLORS.DARK_GRAY;

const BreadcrumbTrail: React.FC<BreadcrumbTrailProps> = ({
  segments,
  ariaLabel = "breadcrumb"
}) => {
  if (!segments.length) {
    return null;
  }

  return (
    <Breadcrumbs
      aria-label={ariaLabel}
      separator={
        <Box
          component="span"
          sx={{
            alignItems: "center",
            color: linkSlate,
            display: "inline-flex",
            lineHeight: 1,
            mx: 1,
            typography: "body_sm",
            userSelect: "none"
          }}
          aria-hidden
        >
          &gt;
        </Box>
      }
      sx={{
        width: "100%",
        alignItems: "center",
        "& .MuiBreadcrumbs-li": {
          display: "inline-flex",
          alignItems: "center"
        },
        "& .MuiBreadcrumbs-separator": {
          marginLeft: 0,
          marginRight: 0
        }
      }}
    >
      {segments.map((segment, index) => {
        const key =
          typeof segment.label === "string"
            ? `${index}-${segment.label}`
            : index;

        if (segment.to) {
          return (
            <Typography
              key={key}
              component={RouterLink}
              to={segment.to}
              variant="body_sm"
              sx={{
                color: linkSlate,
                textDecoration: "none",
                "&:hover": {
                  color: currentMuted
                }
              }}
            >
              {segment.label}
            </Typography>
          );
        }

        return (
          <Typography
            key={key}
            variant="body_sm"
            component="span"
            sx={{ color: currentMuted }}
          >
            {segment.label}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );
};

export default BreadcrumbTrail;
